<template>
  <div class="container-fluid">
    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <!-- 面談日期 -->
          <div class="col-sm-12 col-md-4">
            <div class="form-group">
              <label for="">面談日期</label>
              <ValidationProvider
                :rules="{ dateRangeRequired: true }"
                v-slot="{ errors }"
              >
                <el-date-picker
                  class="w-100"
                  clearable
                  type="daterange"
                  :picker-options="{
                    disabledDate: $common.disabledDateAfterToday,
                  }"
                  range-separator="-"
                  start-placeholder="開始日期"
                  end-placeholder="結束日期"
                  v-model="interviewDateRange"
                />
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>
          <div class="col-sm-12 col-md-4">
            <div class="form-group">
              <label for=""> 需求單位 </label>
              <el-input
                clearable
                placeholder="請輸入關鍵字"
                v-model.trim="searchCondition.applicantDepartment"
              />
            </div>
          </div>
          <div class="col-sm-12 col-md-4">
            <div class="form-group">
              <label for="">單位面試主管</label>
              <el-select
                class="w-100"
                filterable
                clearable
                placeholder="請選擇"
                v-model="searchCondition.InterviewSupervisor"
              >
                <el-option
                  v-for="supervisor in supervisorOptions"
                  :key="supervisor.Guid"
                  :label="supervisor.Name"
                  :value="supervisor.Name"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- HR 面試人員 -->
          <div class="col-sm-12 col-md-4">
            <div class="form-group">
              <label for="">HR 面試人員</label>
              <el-select
                class="w-100"
                filterable
                clearable
                placeholder="請選擇"
                v-model="searchCondition.InterviewHR"
              >
                <el-option
                  v-for="supervisor in supervisorOptions"
                  :key="supervisor.Guid"
                  :label="supervisor.Name"
                  :value="supervisor.Name"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="col-sm-12 col-md-4">
            <div class="form-group">
              <label for=""> 職缺編號 </label>
              <el-input
                clearable
                placeholder="請輸入關鍵字"
                v-model.trim="searchCondition.manpowerDemandNo"
              />
            </div>
          </div>

          <div class="col-sm-12 col-md-4">
            <div class="form-group">
              <label for="">職缺名稱</label>
              <el-input
                clearable
                placeholder="請輸入關鍵字"
                v-model.trim="searchCondition.manpowerDemandName"
              />
            </div>
          </div>

          <div class="col-sm-12 col-md-4">
            <div class="form-group">
              <label for="">{{ i18n("Basic.Candidate") }}</label>
              <el-input
                clearable
                placeholder="請輸入關鍵字"
                v-model.trim="searchCondition.interviewee"
              />
            </div>
          </div>

          <div class="col-sm-12 col-md-4">
            <div class="form-group">
              <label for="">面談結果</label>
              <el-select
                class="w-100"
                clearable
                placeholder="全部"
                v-model="searchCondition.approvalResult"
              >
                <el-option label="複試" value="複試" />
                <el-option label="錄取" value="錄取" />
                <el-option label="考慮中" value="考慮中" />
                <el-option label="不錄取" value="不錄取" />
              </el-select>
            </div>
          </div>

          <div class="col-sm-12 col-md-4">
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px"
              @click="
                (currentPage = 1),
                  getInterviewResult()
              "
            >
              查詢
            </button>

            <button
              type="button"
              class="btn btn-secondary"
              style="margin-top: 30px; margin-left: 10px"
              @click="
                searchCondition = {};
                interviewDateRange = [];
              "
            >
              清除
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 卡片顯示樣式 -->
    <div class="tool-list" v-if="personList.length > 0">
      <span class="mr-2">共計：{{ totalPerson }}人</span>
      <CardStyle v-if="personList.length > 0" @changeStyle="changeStyle" />
    </div>

    <!-- 人員卡片 -->
    <div
      class="person-card-list"
      :class="{
        'list-style': gridStyle == 'list',
        'block-style': gridStyle == 'block',
      }"
    >
      <div
        v-for="(person, index) in personList"
        :key="index"
        class="person-card infinite-list-item"
      >
        <PersonCard ref="personCard" :showCheckbox="false" :person="person">
          <template v-slot:tag="{ props }">
            <div class="result">{{ props.ApprovalResult }}</div>
          </template>

          <template v-slot:middleContent="{ props }">
            <table>
              <tr>
                <th>職缺名稱</th>
                <td>{{ props.ManpowerDemandName }}</td>
              </tr>
              <tr>
                <th>應徵職務</th>
                <td>{{ props.Position }}</td>
              </tr>
              <tr>
                <th>面談日期</th>
                <td>{{ $common.dateTimeFormatter(props.InterviewDate) }}</td>
              </tr>
              <tr>
                <th>單位面試主管</th>
                <td>{{ props.InterviewSupervisor[0] }}</td>
              </tr>
              <tr>
                <th>HR 面試人員</th>
                <td>{{ props.InterviewHR[0] }}</td>
              </tr>
              <tr>
                <th>是否發過感謝函</th>
                <td>
                  <span v-if="props.SendThankNoticeTime === null">否</span>
                  <span v-else>是</span>
                </td>
              </tr>
            </table>
          </template>

          <template v-slot:buttonGroup="{ props }">
            <el-dropdown>
              <button type="button" class="el-dropdown-link">
                檢視資訊<i class="el-icon-arrow-down el-icon--right"></i>
              </button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="showDetailModal(props)">
                  檢視履歷
                </el-dropdown-item>
                <el-dropdown-item @click.native="showProgressRecord(props)">
                  檢視歷程
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <button
              v-if="
                props.ApprovalResult === '錄取' ||
                props.ApprovalResult === '考慮中'
              "
              type="button"
              @click="createAppointmentForm(props)"
            >
              起任用單
            </button>
            <template v-if="props.ApprovalResult === '不錄取'">
              <button
                v-if="props.SendThankNoticeTime === null"
                type="button"
                @click="sendThanksMail(props)"
              >
                發感謝函
              </button>
              <el-tooltip
                v-else
                class="item"
                effect="light"
                content="已發過感謝函"
                placement="top"
              >
                <button type="button" @click="sendThanksMail(props)">
                  發感謝函
                </button>
              </el-tooltip>
            </template>
            <button type="button" @click="getApproveInterview(props)">
              面談評估
            </button>
          </template>
        </PersonCard>
      </div>
    </div>

    <!-- 分頁 -->
    <el-pagination
      v-if="personList.length > 0"
      background
      layout="prev, pager, next"
      :total="totalPerson"
      :page-size="9"
      @current-change="changePage"
    >
    </el-pagination>

    <!-- 感謝函 Modal-->
    <ThanksMailModal
      :personData="personData"
      @getLatestSearchResult="getInterviewResult"
    />

    <!-- 面談評估 -->
    <EvaluateInterviewModal
      :Source="'InterviewResult'"
      :AdmitOptions="admitOptions"
      :IdlRejectOptions="idlRejectOptions"
      :DlRejectOptions="dlRejectOptions"
      :Person="personData"
      @saveApproveInterview="saveApproveInterview"
    />

    <!-- 各資訊總覽 -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-modal" v-if="isShowDetail">
        <div class="detail-modal-inner">
          <div class="menu">
            <a @click.prevent="detailCurrentPage = 0">
              <span>
                <eva-icon name="person-outline" fill="#FFF"></eva-icon>
                履歷
              </span>
            </a>
            <a @click.prevent="detailCurrentPage = 1">
              <span>
                <eva-icon name="message-circle-outline" fill="#FFF"></eva-icon>
                面談紀錄
              </span>
            </a>
            <div
              class="close-show-detail"
              @click.prevent="isShowDetail = !isShowDetail"
            >
              <eva-icon
                name="close-circle"
                fill="#FFF"
                width="50"
                height="50"
              ></eva-icon>
            </div>
          </div>
          <div class="page-wrap">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 0" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">履歷</div>
                    <div class="item text-right">
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="$common.downloadResumePDF(ResumeType, ResumeId)"
                      >
                        下載 PDF
                      </button>
                    </div>
                  </div>
                  <IdlResume
                    v-if="ResumeType === 'IDL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                  <DlResume
                    v-if="ResumeType === 'DL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                </section>
              </perfect-scrollbar>
            </transition>
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 1" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">面談紀錄</div>
                    <div class="item"></div>
                  </div>
                  <InterviewRecord :MatchId="MatchId"></InterviewRecord>
                </section>
              </perfect-scrollbar>
            </transition>
          </div>
        </div>
      </div>
    </transition>

    <!-- 檢視歷程 -->
    <ProgressRecordModal :Name="Name" :UserId="UserId" :Email="Email" />
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
import Logo from "@/components/company/Logo.vue";
// 卡片樣式
import CardStyle from "@/components/back/Card/CardStyle";
// 人員卡片
import PersonCard from "@/components/back/Card/Person";
// 感謝函
import ThanksMailModal from "@/components/back/Modal/ThanksMail";
// 履歷(DL/IDL)
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";
// 面談紀錄
import InterviewRecord from "@/components/back/CandidateData/InterviewRecord";
// 面談評估
import EvaluateInterviewModal from "@/components/back/Modal/EvaluateInterview";
// 歷程
import ProgressRecordModal from "@/views/back/TalentQuery/ResultPage/Modal/ProgressRecord";

export default {
  name: "Progress_InterviewResult",

  components: {
    Logo,
    CardStyle,
    PersonCard,
    ThanksMailModal,
    IdlResume,
    DlResume,
    InterviewRecord,
    EvaluateInterviewModal,
    ProgressRecordModal,
  },
  data() {
    return {
      // 卡片顯示樣式 有 block / list 兩種
      gridStyle: "block",

      // 查詢條件
      searchCondition: {},
      supervisorOptions: [],
      interviewDateRange: [],

      // 面談評估 Modal
      admitOptions: [], // 錄取[備註]選項
      idlRejectOptions: [], // idl-不錄取[原因]選項
      dlRejectOptions: [], // dl-不錄取[原因]選項
      
      // 檢視資訊
      MatchId: null,
      ResumeId: null,
      isShowDetail: false, // 預設不顯示
      detailCurrentPage: 0, // 點擊選項
      ResumeType: null, // 履歷種類

      // 檢視歷程
      Name: null,
      UserId: null,
      Email: null,

      // 人員資料
      personData: {},

      // 人員圖卡
      personList: [],

      // 分頁
      totalPerson: 0, // 共幾筆
      currentPage: 1, // 當前第幾頁
    };
  },

  methods: {
    // 取得 面談結果
    getInterviewResult() {
      this.updateLoading(true);
      this.$store.commit("ScrollTop", true);

      this.$api.hr
        .getInterviewResultPaging(
          {
            ...this.searchCondition,
            interviewDateStart: this.interviewDateRange
              ? this.$common.dateFormatter(this.interviewDateRange[0])
              : null,
            interviewDateEnd: this.interviewDateRange
              ? this.$common.dateFormatter(this.interviewDateRange[1])
              : null,
            Page: this.currentPage,
            PerPage: 9,
          }
        )
        .then((response) => {
          if (response.status === 200) {
            if (response.data.Quantity > 0) {
              this.totalPerson = response.data.Quantity;
              this.personList = response.data.Datas;
              this.$store.commit("ScrollTop", false);
            }
          }
          this.updateLoading(false);
        });
    },

    // 換頁
    changePage(page) {
      this.currentPage = page;
      this.getInterviewResult();
    },

    // 取得面談評估
    getApproveInterview(props) {
      this.personData = props;
      this.$store.commit("OpenEvaluateInterviewModal", true);
    },

    // 完成面談評估
    saveApproveInterview(params) {
      this.$store.commit("OpenEvaluateInterviewModal", false);
      this.updateLoading(true);

      this.$api.approveInterview
        .putApproveInterview(params)
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "儲存成功",
              type: "success",
              duration: 2500,
            });
            this.currentPage = 1;
            this.getInterviewResult();
          }
          this.updateLoading(false);
        });
    },

    // 起任用單
    createAppointmentForm(item) {
      this.$router.push({
        path: `/manager/form/evaluation/create/${item.MatchId}`,
      });
    },

    // 感謝函
    sendThanksMail(person) {
      this.personData = {
        Name: person.Name,
        Position: person.Position,
        MatchId: [person.MatchId],
      };
      this.$store.commit("OpenThanksMailModal", true);
    },

    // 檢視資訊 Modal
    showDetailModal(person) {
      this.MatchId = person.MatchId;
      this.ResumeId = person.ResumeId;
      this.ResumeType = person.ResumeType;
      this.isShowDetail = true;
    },

    // 檢視歷程
    showProgressRecord(person) {
      this.MatchId = person.Id;
      this.Name = person.Name;
      this.UserId = person.UserId;
      this.Email = person.Email;
      this.$store.commit("OpenCandidateProcessModal", true);
    },

    // 卡片樣式
    changeStyle(style) {
      this.gridStyle = style;
    },

    async getData() {
      try {
        // 取得錄取的[備註]下拉選單
        const admit = await this.$api.recruitment.getInterviewBasicCondition();
        // 取得idl不錄取的[原因]下拉選單
        const idl = await this.$api.recruitment.getInterviewNotAdmitReason({
          ResumeType: "IDL",
          IsNotAdmitReason: true,
        });
        // 取得dl不錄取的[原因]下拉選單
        const dl = await this.$api.recruitment.getInterviewNotAdmitReason({
          ResumeType: "DL",
          IsNotAdmitReason: true,
        });
        // 取得 主管列表
        const backgroundUser =
          await this.$api.backgroundUser.getBackgroundUser();
        this.admitOptions = admit.data;
        this.idlRejectOptions = idl.data;
        this.dlRejectOptions = dl.data;
        this.supervisorOptions = backgroundUser.data.map((user) => {
          return {
            Guid: user.UserId,
            Name: user.Name,
          };
        });
      } catch (error) {
        this.$notify({
          title: error.name,
          message: error.message + "請聯繫系統管理員",
          type: "error",
          duration: 0,
        });
      }
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  watch: {
    isShowDetail: function (e) {
      if (!e) {
        this.detailCurrentPage = 0;
      }
    },
  },

  mounted() {
    this.getInterviewResult();
    this.getData();
    $("#message").tooltip("enable");
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>
